<template>
	<div class="options">
		<div class="backdrop"></div>
		<div class="content">
			<div class="close" @click="close">×</div>
			<div class="code">
				<img class="code-icon" :src="getBenefitImageUrl(overlaydata.benefit)" >
			</div>
			<div class="title">{{overlaydata.benefit.venueTitle}}</div>
			<div class="description" v-html="getSafeBenefitText(overlaydata.benefit.benefitOffer)"></div>
			<div class="description">{{overlaydata.benefit.benefitCode}}</div>
			<div class="footer" v-if="overlaydata.benefit.benefitVoidingsCount < overlaydata.benefit.maxAmountOfVoidings" @click="voidBenefit(overlaydata.benefit.id, overlaydata.benefit.benefitVoidingType, overlaydata.communeId)">
				<font-awesome-icon icon="star" class="footer-icon"/>
				<NewTranslation class="footer-text" @click="close" path="couponGuideOverlay.redeem.button" />
			</div>
			<div class="footer" v-if="overlaydata.benefit.benefitVoidingsCount >= overlaydata.benefit.maxAmountOfVoidings">
				<font-awesome-icon icon="star" class="footer-icon"/>
				<NewTranslation class="footer-text" @click="close" path="couponGuideOverlay.alreadyRedeemed.label" />
			</div>			
		</div>
	</div>
</template>

<script>
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';
import i18next from 'i18next';
import RemoteAssets from '@/app/utils/RemoteAssets';
import { NamedRoutes } from '@/routes/routes';

export default {
  components: {
    NewTranslation,
    Button,
  },
  props: ['overlaydata'],
  methods: {
    close() {
      this.$store.commit('openOverlay', '');
    },
    redeem() {
      // if(this.overlaydata && this.overlaydata.redeem) this.overlaydata.redeem()
      this.$store.commit('openOverlay', 'CouponDetail');
    },
    voidBenefit(benefitId, benefitVoidingType, communeId) {
      // @DEBUG
      this.$axios
        .post(
          `${process.env.VUE_APP_API_BASEURL}/v2/benefit/${localStorage.getItem('customerUUID')}`,
          {
            benefitId,
			communeId
          },
          { withCredentials: true }
        )
        .then(response => {
			if (response.data && response.data.code && response.data.code == "OK") {
				this.$store.commit('voidBenefit', benefitId);
				this.showInfo(i18next.t(`couponGuideOverlay.request.success.dialog.text${benefitVoidingType}`), i18next.t('couponGuideOverlay.request.success.dialog.title'));
			} else {
				this.showInfo(i18next.t('couponGuideOverlay.request.error.dialog.text'), i18next.t('couponGuideOverlay.request.error.dialog.title'));
				this.$router.push({ name: NamedRoutes.splash })
			}
        })
        .catch(error => {
          if (error.response)
            this.showInfo(i18next.t('couponGuideOverlay.request.error.dialog.text'), i18next.t('couponGuideOverlay.request.error.dialog.title'));
          else this.showInfo(error, i18next.t('couponGuideOverlay.request.unknownError.dialog.title'));
        });
    },
    showInfo(message, title) {
      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          title,
          message,
        },
      });
    },
    getBenefitImageUrl(benefit) {
      if (benefit.venueImage) {
        return RemoteAssets.benefitImageUrl(benefit.venueImage);
      } else if (benefit.externalImg) {
        return benefit.externalImg;
      }
	  return '';
    },	
    getSafeBenefitText(value) {
      if (value) {
        const resultParsed = `<div class="benefit-safe-text-wrapper">${value}</div>`;
        return resultParsed;
      }
      return '';
    }	
  },
};
</script>

<style lang="sass" scoped>
.options
	width: 100%
	height: 100vh
	display: flex
	flex-direction: column
	align-items: center
	justify-content: center
	position: fixed
	max-width: 480px
	margin: 0 auto
	right: 0
	top: 0
	left: 0
	z-index: 9
.backdrop
	background-color: rgba(0, 0, 0, .8)
	width: 100%
	height: 100vh
	position: absolute
	z-index: 6
.close
	position: absolute
	right: 20px
	top: 20px
	background-color: #fff
	z-index: 9
	color: #1DB2D1
	border: 1px solid #1DB2D1
	width: 20px
	height: 20px
	display: flex
	justify-content: center
	align-items: center
	border-radius: 20px
.content
	z-index: 7
	// background-color: #fff
	border-radius: 10px
	padding: 60px 0 0
	margin: 20px
	position: relative
	overflow: hidden
.code
	background-color: #543
	position: absolute
	top: 0
	left: 0
	right: 0
	height: 60px
	text-align: right
	padding-right: 50px
	padding-top: 20px
	line-height: 1
	color: #ffffff
	font-size: 1.25rem
	&-icon
		width: 60px
		height: 60px
		object-fit: cover
		position: absolute
		left: 25px
		top: 10px
		border-radius: 40px
		border: 3px solid #fff
		box-shadow: 0 5px 3px rgba(0, 0, 0, .1)
.title
	font-size: 1.25rem
	color: #000
	background-color: #eaeaea
	height: 60px
	padding: 20px
	line-height: 1
	font-weight: bold
.description
	display: block
	color: #454F63
	padding: 5px 20px
	background-color: #ffffff
.info
	display: block
	color: #454F63
	padding: 20px
	background-color: #fff
	border-top: 1px solid #ddd
.footer
	background-color: #eaeaea
	color: #1DB2D1
	font-size: 1.25rem
	padding: 20px
	height: 60px
	line-height: 1
	display: flex
	&-icon
		width: 20px
		margin-right: 10px
	// &-text
.button
	margin-top: 20px
</style>
